import { FormControl } from "@angular/forms";
const CPF = require('cpf')
const CNPJ = require('cnpj')

export function cpfCnpjValidator(control: FormControl) {
    const value = control.value;
    if (value !== undefined && value !== null && value !== '') {
        const hasAlpha = /[A-Za-z]/.test(value);
        const cleanValue = (value.match(/[A-Za-z0-9]/g) || []).join('');
        const length = cleanValue.length;
        if (length > 11) {
            if (hasAlpha) {
                // Se possui alphanumeric, valida apenas se tem 14 caracteres
                if (length !== 14) {
                    return { cnpj: true };
                }
            } else {
                // CNPJ normal
                if (!CNPJ.validate(value)) {
                    return { cnpj: true };
                }
            }
        } else {
            if (!CPF.isValid(value)) {
                return { cpf: true };
            }
        }
    }

    return null;
}